/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './components/baMenuItem/baMenuItem.component.ngfactory';
import * as i2 from '../../../../../app/theme/components/baMenu/components/baMenuItem/baMenuItem.component';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '../../../../../app/theme/components/baMenu/baMenu.component';
import * as i5 from '../../../../../app/theme/directives/baSlimScroll/baSlimScroll.directive';
import * as i6 from '@angular/common';
import * as i7 from '@angular/router';
import * as i8 from '../../../../../app/theme/services/baMenu/baMenu.service';
import * as i9 from '../../../../../app/global.state';
const styles_BaMenu:any[] = ([] as any[]);
export const RenderType_BaMenu:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_BaMenu,
    data:{}});
function View_BaMenu_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'ba-menu-item',
      ([] as any[]),(null as any),[[(null as any),'itemHover'],[(null as any),'toggleSubMenu']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('itemHover' === en)) {
          const pd_0:any = ((<any>_co.hoverItem($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('toggleSubMenu' === en)) {
          const pd_1:any = ((<any>_co.toggleSubMenu($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i1.View_BaMenuItem_0,i1.RenderType_BaMenuItem)),i0.ɵdid(1,49152,(null as any),
      0,i2.BaMenuItem,[i3.TranslateService],{menuItem:[0,'menuItem']},{itemHover:'itemHover',
          toggleSubMenu:'toggleSubMenu'})],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_BaMenu_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),15,'aside',[['class',
      'al-sidebar'],['sidebarResize','']],(null as any),[[(null as any),'mouseleave']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:i4.BaMenu = _v.component;
        if (('mouseleave' === en)) {
          const pd_0:any = ((<any>(_co.hoverElemTop = _co.outOfArea)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i0.ɵeld(2,0,(null as any),(null as any),6,'ul',[['baSlimScroll',''],
          ['class','al-sidebar-list'],['id','al-sidebar-list']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i0.ɵdid(3,540672,(null as any),
          0,i5.BaSlimScroll,[i0.ElementRef],{baSlimScrollOptions:[0,'baSlimScrollOptions']},
          (null as any)),i0.ɵpod(4,{height:0}),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BaMenu_1)),
      i0.ɵdid(7,802816,(null as any),0,i6.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),
          i0.ɵeld(10,0,(null as any),(null as any),4,'div',[['class','sidebar-hover-elem']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(11,278528,(null as any),0,i6.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,
          i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,'ngClass']},(null as any)),
      i0.ɵpod(12,{'show-hover-elem':0}),i0.ɵdid(13,278528,(null as any),0,i6.NgStyle,
          [i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{ngStyle:[0,'ngStyle']},(null as any)),
      i0.ɵpod(14,{top:0,height:1}),(_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),
          i0.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i4.BaMenu = _v.component;
    const currVal_0:any = _ck(_v,4,0,_co.menuHeight);
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _co.menuItems;
    _ck(_v,7,0,currVal_1);
    const currVal_2:any = 'sidebar-hover-elem';
    const currVal_3:any = _ck(_v,12,0,_co.showHoverElem);
    _ck(_v,11,0,currVal_2,currVal_3);
    const currVal_4:any = _ck(_v,14,0,(_co.hoverElemTop + 'px'),(_co.hoverElemHeight + 'px'));
    _ck(_v,13,0,currVal_4);
  },(null as any));
}
export function View_BaMenu_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'ba-menu',([] as any[]),
      (null as any),(null as any),(null as any),View_BaMenu_0,RenderType_BaMenu)),
      i0.ɵdid(1,245760,(null as any),0,i4.BaMenu,[i7.Router,i8.BaMenuService,i9.GlobalState],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const BaMenuNgFactory:i0.ComponentFactory<i4.BaMenu> = i0.ɵccf('ba-menu',i4.BaMenu,
    View_BaMenu_Host_0,{sidebarCollapsed:'sidebarCollapsed',menuHeight:'menuHeight'},
    {expandMenu:'expandMenu'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/theme/components/baMenu/baMenu.component.ngfactory.ts